module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Wedge SOC")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "soc-navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.userIsAdmin) ? _c('li', {
    staticClass: "dropdown",
    class: _vm.pathPrefixMatches('/admin') ? 'active' : ''
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'adminUsers'
      }
    }
  }, [_c('a', [_vm._v("Users")])])], 1)]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'serial-list'
      }
    }
  }, [_c('a', [_vm._v("Serial")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'license'
      }
    }
  }, [_c('a', [_vm._v("License")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'sandbox'
      }
    }
  }, [_c('a', [_vm._v("Malware Analyzer")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: _vm.pathPrefixMatches('/soc/report') ? 'active' : ''
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'reportSecurityEvent'
      }
    }
  }, [_c('a', [_vm._v("Security Events")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'reportLicenseExpiry'
      }
    }
  }, [_c('a', [_vm._v("License Expiry")])])], 1)])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown",
    class: _vm.pathPrefixMatches('/user') ? 'active' : ''
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.userProfile.email) + "\n            "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userProfile'
      }
    }
  }, [_vm._v("User Profile")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_vm._v("Logout")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#soc-navbar",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Admin "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Reports "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4edfbe8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 497
// module chunks = 2